<template>
  <action-dispatcher
    @success="setMainOffer"
    action="product/getProduct"
    :parameters="$route.params.id"
  >
    <page-container>
      <h2 class="mb-6">Editar oferta principal</h2>
      <bp-input
        id="name"
        disabled
        v-model="form.name"
        label="Nome da oferta"
        description="Este nome será exibido apenas para você, em sua tabela de preços."
      />
      <bp-input
        rows="5"
        textarea
        class="mt-6"
        id="description"
        disabled
        v-model="form.description"
        label="Descrição no checkout"
        :limit="980"
        size="xl"
      />

      <hr />

      <h3>Precificação</h3>

      <bp-input
        v-model="form.price"
        money
        required
        class="my-5"
        placeholder="Informe o preço"
        label="Valor em Real Brasileiro (R$)"
        preIcon="fa-light fa-brazilian-real-sign"
        description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que R$ 4,00."
        :min="4"
        :errors="errors.price"
        :moneyConfig="moneyConfig"
      />
      <bp-input
        v-if="!isParcelledBillet"
        :disabled="!showForeign"
        :info="getInfo('USD')"
        v-model="form.price_usd"
        money
        class="my-5"
        preIcon="fa-light fa-dollar"
        placeholder="Informe o preço"
        label="Valor em Dólar Americano (US$)"
        description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que US$ 4,00."
        :min="4"
        :errors="errors.price_usd"
        :moneyConfig="{ ...moneyConfig, currency: '$' }"
      />
      <bp-input
        v-if="!isParcelledBillet"
        :disabled="!showForeign"
        :info="getInfo('EUR')"
        v-model="form.price_eur"
        money
        class="my-5"
        label="Valor em Euro (€)"
        preIcon="fa-light fa-euro"
        placeholder="Informe o preço"
        description="Defina quanto custará o seu produto. Certifique-se de que o valor não seja menor que € 4,00."
        :min="4"
        :errors="errors.price_eur"
        :moneyConfig="{ ...moneyConfig, currency: '€' }"
      />

      <action-dispatcher
        v-if="form.price && form.price >= 4"
        action="sale/getInstallments"
        :key="`${form.price}`"
        :parameters="{
          product_id: $route.params.id,
          value: form.price,
          installments: 18
        }"
      >
        <bp-select
          select
          class="mt-6"
          id="installment"
          label="Parcelamento"
          placeholder="Selecionar..."
          description="Defina o número máximo de parcelas."
          v-model="form.installments"
          :options="installmentOptions"
          :errors="errors.installments"
        />
      </action-dispatcher>
      <div class="d-flex flex-column flex-md-row justify-content-between my-9">
        <bp-button
          color="neutral"
          class="order-1 order-md-0"
          variant="filled-1"
          :route="{
            name: 'product-prices',
            params: { id: $route.params.id }
          }"
          label="Cancelar"
        />
        <bp-button
          :color="isValid ? 'primary' : 'neutral'"
          :disabled="!isValid"
          :loading="loading"
          label="Salvar oferta principal"
          @click="submit"
        >
        </bp-button>
        <div class="d-md-none my-3"></div>
      </div>
    </page-container>
  </action-dispatcher>
</template>
<script>
import { formatMoney, formFields } from "@/functions/helpers";
import { defaultOffer } from "@/functions/product";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "id",
          "name",
          "description",
          "price",
          "price_usd",
          "price_eur",
          "currency",
          "installments",
          "status"
        ],
        {
          status: "active",
          currency: "BRL"
        }
      ),
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "",
        masked: false
      }
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("offer", ["offer", "orderBumpOffers"]),
    ...mapState("sale", ["installments"]),
    installmentOptions() {
      const opts = [];
      for (let id in this.installments) {
        opts.push({
          id: parseInt(id),
          name: `Até ${id} parcela${id - 1 ? "s" : ""} de R$ ${formatMoney(
            this.installments[id]
          )}`
        });
      }
      return opts;
    },
    isValid() {
      return (
        this.form.name &&
        this.form.description &&
        this.form.currency &&
        this.form.price &&
        this.form.price >= 4 &&
        (!this.hasUSD || this.form.price_usd >= 4) &&
        (!this.hasEUR || this.form.price_eur >= 4)
      );
    },
    showForeign() {
      return this.product.payment_methods?.some(({ id }) => id === 1);
    },
    hasUSD() {
      return !!this.form.price_usd && this.form.price_usd > 0;
    },
    hasEUR() {
      return !!this.form.price_eur && this.form.price_eur > 0;
    },
    isParcelledBillet() {
      return this.product?.billet_installments > 1;
    }
  },

  methods: {
    getInfo(currency) {
      if (this.showForeign) return "";
      const currencyName = {
        USD: "dólar americano",
        EUR: "euro"
      };
      return `Para habilitar configuração de preço em ${currencyName[currency]} seu checkout precisa aceitar Cartão de Crédito. Atualize a configuração de "Opções de Pagamento" do seu produto em "Configurar Checkout"`;
    },
    setMainOffer(product) {
      this.form = { ...this.form, ...defaultOffer(product) };
    },
    submit() {
      this.loading = true;
      const { price, price_eur, price_usd, installments } = this.form;
      this.$store
        .dispatch("product/put", {
          price,
          price_usd: parseFloat(price_usd) || null,
          price_eur: parseFloat(price_eur) || null,
          installments,
          id: this.$route.params.id
        })
        .then(() => {
          this.$message.success("Oferta principal salva com sucesso!");
          this.$router.push({
            name: "product-prices",
            params: { id: this.$route.params.id }
          });
        })
        .catch(error => {
          let msg = get_error_msg(
            error?.response?.data,
            TRANSLATE_FIELD_PRICE_MAP,
            "Erro ao salvar oferta"
          );
          this.$message.error(msg);
        })
        .finally(() => (this.loading = false));
      return;
    }
  }
};
</script>
